import React, { useCallback } from "react";
import { strings } from "../../../../intl/fa";
import Wrapper from "../../../commons/wrapper/Wrapper";
import Header, { NavType } from "../../../commons/header/Header";
import { useAppDispatch, useAppSelector } from "../../../../utils/store";
import {
  AppPage,
  NavigationActions,
} from "../../../../core/navigation/navigation.slice";
import { OrdersListActions } from "../../../../core/ordersList/ordersList.slice";
import { DialogAdDetails } from "./dialogAdDetails/dialogAdDetails";
import { CampaignDetails } from "./campaignDetails/campaignDetails";

export const OrderDetails: React.FC<React.PropsWithChildren<unknown>> = () => {
  const selectedAd = useAppSelector((state) => state.ordersList.selectedOrder);
  const dispatch = useAppDispatch();

  let Component;
  if (selectedAd) {
    Component = DialogAdDetails;
  } else {
    Component = CampaignDetails;
  }

  const onClose = useCallback(() => {
    dispatch(NavigationActions.setAppPage(AppPage.OrdersList));
    dispatch(OrdersListActions.setSelectedCampaign(undefined));
    dispatch(OrdersListActions.setSelectedAd(undefined));
  }, []);

  return (
    <Wrapper>
      <Header
        onClose={onClose}
        navType={NavType.both}
        title={strings.order_details.page_title}
      />
      <Component />
    </Wrapper>
  );
};
